import { ethers } from 'ethers';

import type { BigNumberish } from '@ethersproject/bignumber';

const defaultDecimals = 18;

export const numberToWei = (num: number | string, decimals = defaultDecimals) => {
  const value =
    typeof num === 'number'
      ? new Intl.NumberFormat('en-US', {
          useGrouping: false,
          maximumFractionDigits: decimals,
          //eslint-disable-next-line
          //@ts-ignore
          roundingMode: 'trunc',
        }).format(num)
      : num.replace(new RegExp(`(?<=\\.\\d{${decimals}})\\d+`), '');

  return ethers.utils.parseUnits(value, decimals);
};

export const weiToNumber = (wei: BigNumberish, decimals = defaultDecimals) => {
  return parseFloat(ethers.utils.formatUnits(wei, decimals));
};
